<template>
	<div>
		<div class="listbox" @click="To(data)" v-if="!data.type">
			<p class="textp one"><span class="icon"></span>{{data.title}}</p>
			<p class="time">{{data.publishtime_text.split(' ')[0]}}</p>
		</div>
		<van-row class="listbox" type="flex" justify="space-between" @click="To(data)"  v-else>
			<van-col span="7">
				<van-image width="100%" fit="contain" :src="require('../assets/images/notice/tu1.png')" />
			</van-col>
			<van-col span="17" class="padding">
				<p class="textp tow">{{data.title}}</p>
				<p class="time" style="padding-left: 0;">{{data.publishtime_text.split(' ')[0]}}</p>
			</van-col>
		</van-row>
	</div>
</template>

<script>
	export default {
		name: 'listbox',
		props: {
			data: { /* 题目所有数据 */
				type: [Object, String],
				default: ''
			},
		},
		data() {
			return {
				
			}
		},
		methods: {
			To(itme) {
				this.$emit("To", itme) /* 打错是否展示答案详解 */
			}
		},
		mounted() {


		},

	}
</script>

<style lang="scss" scoped>
	.listbox {
		padding: 1rem 1.3rem;
		border-bottom: 1px solid rgba(222, 222, 222, .5);

		.textp {
			font-size: 1.4rem;
			text-align: left;
			line-height: 2rem;
			margin-bottom: 0.4rem;
			color: #333333;
			.icon {
				display: inline-block;
				margin-right: 5px;
				width: 0.8rem;
				height: 0.8rem;
				border-radius: 2px;
				background-color: #fa6b6b;
			}
		}
		.one{
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
		.tow {
			display: -webkit-box;
			-webkit-box-orient: vertical;
			overflow: hidden;
			text-overflow: ellipsis;
			word-break: break-all;
			-webkit-line-clamp: 2;
		}

		.time {
			text-align: left;
			font-size: 1.4rem;
			color: rgba(51, 51, 51, .46);
			padding-left: calc(0.8rem + 5px);
		}
	}
	.padding{
		padding-left: 1rem;
	}
</style>
